import { render, staticRenderFns } from "./QcqCompetence.vue?vue&type=template&id=491c4d56&scoped=true&lang=pug&"
import script from "./QcqCompetence.vue?vue&type=script&lang=ts&"
export * from "./QcqCompetence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491c4d56",
  null
  
)

export default component.exports